import store from '@/store'

const { staticModule } = store.state
export default function permission() {
  const getPermissions = exam => {
    const perm = {
      can_send: false,
    }
    const examPermissions = exam.exam_permissions ? exam.exam_permissions : {}
    return {
      ...perm,
      ...examPermissions,
    }
  }
  const canFinish = exam => exam.exam_file_permission
  const canAddFile = exam => exam.exam_file_permission
  const canRemoveFile = exam => exam.status === staticModule.examStatusDraft

  const canSend = exam => getPermissions(exam).can_send

  const canAddAsAdditional = (exam, examResult) => exam.status === staticModule.examStatusFinish && examResult.is_accepted === staticModule.examResultNotAccepted
  const canReAddAsAdditional = (exam, examResult) => exam.status === staticModule.examStatusFinish && examResult.is_accepted === staticModule.examResultAdditionalAccepted
  return {
    canSend,
    canFinish,
    canAddFile,
    canRemoveFile,
    canAddAsAdditional,
    canReAddAsAdditional,
  }
}
